import {Component, OnInit} from '@angular/core';
import {CardActivationImportError} from '../../../../dto/card-activation-import-error';
import {ActivatedRoute, Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import {DateFormats} from '../../../../providers/app-date-adapter';
import {CardActivation} from '../../../../dto/card-activation';
import {MatTableDataSource} from '@angular/material/table';
import {TotalStatsImport} from '../../../../dto/total-stats-import';
import {TotalStatsTransaction} from '../../../../dto/total-stats-transaction';
import {TotalStatsImportError} from '../../../../dto/total-stats-import-error';
import {TotalStatsImportService} from '../../../services/total-stats-import.service';

@Component({
  selector: 'app-card-activation-import-view',
  templateUrl: './total-stats-import-view.component.html',
  styleUrls: ['./total-stats-import-view.component.css']
})
export class TotalStatsImportViewComponent implements OnInit {

  import: TotalStatsImport;
  importData: TotalStatsTransaction[];
  importErrors: TotalStatsImportError[];

  importDataDataSource: MatTableDataSource<TotalStatsTransaction>;
  importErrorsDataSource:  MatTableDataSource<TotalStatsImportError>;

  importCols = [
    { header: 'ID',           cell: (row: TotalStatsImport) => `${row.id}`},
    { header: 'Date',         cell: (row: TotalStatsImport) => `${this.datePipe.transform(row.date, DateFormats.DisplayDateTime)}`},
    { header: 'User',         cell: (row: TotalStatsImport) => `${row.username}`},
    { header: 'Invalid rows', cell: (row: TotalStatsImport) => `${row.invalidRowCount}`},
    { header: 'Total rows',   cell: (row: TotalStatsImport) => `${row.totalRowCount}`},
  ];

  importDataCols = [
    { columnDef: 'id',          header: 'ID',           cell: (row: TotalStatsTransaction) => `${row.id}` },
    { columnDef: 'invoicingDate', header: 'Invoicing Date', cell: (row: TotalStatsTransaction) => `${this.datePipe.transform(row.invoicingDate, DateFormats.DisplayDateTime)}` },
    { columnDef: 'customer', header: 'Customer', cell: (row: TotalStatsTransaction) => {
        if ( row.totalCard != null && row.totalCard.totalStatCustomer != null && row.totalCard.totalStatCustomer.customer != null ) {
          return row.totalCard.totalStatCustomer.customer.firstName + ' ' +
            row.totalCard.totalStatCustomer.customer.lastName;
        }
      }
    },
    { columnDef: 'mop', header: 'MOP', cell: (row: TotalStatsTransaction) => `${row.totalCard ? row.totalCard.mopNumber : '-'}` },
    { columnDef: 'product', header: 'Product', cell: (row: TotalStatsTransaction) => `${row.product ? row.product.productName : '-'}` },
    { columnDef: 'quantitySold', header: 'Qty', cell: (row: TotalStatsTransaction) => `${row.quantity}` },
    { columnDef: 'priceExclVat', header: 'excl', cell: (row: TotalStatsTransaction) => `${row.priceExclVat}` },
    { columnDef: 'priceinclVat', header: 'incl', cell: (row: TotalStatsTransaction) => `${row.priceInclVat}` },

  ];

  importErrorsCols = [
    { columnDef: 'rowNumber',   header: 'Row number',   cell: (row: CardActivationImportError) => `${row.rowNumber}`},
    { columnDef: 'ParsedValue', header: 'Parsed value', cell: (row: CardActivationImportError) => `${row.parsedValue}`},
    { columnDef: 'errorText',   header: 'Error Text',   cell: (row: CardActivationImportError) => `${row.errorText}`},
  ];

  constructor(
    private importService: TotalStatsImportService,
    private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
  ) { }

  ngOnInit() {
    const id = parseInt(this.route.snapshot.paramMap.get('id'));
    this.importService.get(id).subscribe(result => {
      this.import = result;
      this.importDataDataSource = new MatTableDataSource(result.transactions);
      this.importErrorsDataSource = new MatTableDataSource(result.importErrors);
    });
  }

  getRowClass = (item: CardActivation): string => item.importErrorsText ? 'warning-row' : '';
}
